import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Phone } from "lucide-react";
import { CONTACT } from "@/lib/data";
import { Reveal } from "@/lib/motion";

const FAQS = [
  {
    q: "How much is the deposit?",
    a: "$100 for every rental. It's fully refundable — it's only used for tolls or incidentals, and whatever isn't used comes right back to you.",
  },
  {
    q: "How many miles can I drive?",
    a: "Every rental includes 200 miles per day. That's plenty for a full day of rideshare or delivery driving around the metro — no extra charge.",
  },
  {
    q: "Where can I take the car?",
    a: "Rentals stay in the Central Florida area: Orange, Osceola, Lake, Seminole, and Sumter counties. Perfect for working Orlando and the surrounding cities.",
  },
  {
    q: "Is there a minimum rental period?",
    a: "Yes — 3 days for the Tesla and 4 days for the Hyundai. Most renters book by the week and keep the car as long as they need it.",
  },
  {
    q: "What's included with my rental?",
    a: "Your rental includes coverage, maintenance, and 200 miles per day so you can focus on the road.",
  },
  {
    q: "Do you run credit checks?",
    a: "Never. No credit checks and no credit cards needed — a valid driver's license is all it takes to get approved.",
  },
  {
    q: "Can I drive for Uber, Lyft, or delivery apps?",
    a: "Absolutely — that's what we're built for. Uber, Lyft, Instacart, DoorDash, Grubhub and more are all welcome.",
  },
  {
    q: "How do I pay?",
    a: "We keep it simple: Cash App, Venmo, or Apple Pay. Total is due when you pick up the car.",
  },
  {
    q: "What do I need to book?",
    a: "Pick your car and dates (3-day minimum for the Tesla, 4 for the Hyundai), upload a photo of your driver's license for approval, and we'll verify it and reach out to confirm your booking.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="bg-secondary py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="text-gold-dark text-xs font-bold uppercase tracking-[0.3em] mb-4">Good To Know</p>
          <h2 className="font-heading font-bold text-navy text-4xl sm:text-5xl lg:text-[3.4rem] tracking-tight leading-[1.02]">
            Questions? Answered.
          </h2>
          <p className="mt-5 text-muted-foreground text-base md:text-lg leading-relaxed">
            Everything renters ask before booking — deposits, mileage, where you can drive, and how payment works.
          </p>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="faq-call-link"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-white font-semibold hover:bg-navy-light transition-colors"
          >
            <Phone className="w-4 h-4" /> Still curious? Call {CONTACT.phoneDisplay}
          </a>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl bg-white border border-navy/10 px-5 sm:px-6"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-heading font-bold text-navy text-base md:text-lg py-5 hover:no-underline hover:text-gold-dark transition-colors"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-muted-foreground text-sm md:text-base pb-5 leading-relaxed"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
